import { CommunityWins } from '@platform/client';
import { Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';

interface DeleteCommunityWinModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: number;
  page: number;
  limit: number;
}

export const DeleteCommunityWinModal = (props: DeleteCommunityWinModalProps) => {
  const { isOpen, onClose, id, limit } = props;

  const queryClient = useQueryClient();

  const submitCommunityWin = CommunityWins.useDeleteCommunityWin({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [...CommunityWins.getGetCommunityWinsQueryKey({ page: 0, limit })],
        });
      },
    },
  });

  const deleteCommunityWin = async () => {
    submitCommunityWin.mutate({
      data: {
        id,
      },
    });

    closeModal();
  };

  const closeModal = () => {
    onClose();
  };

  return (
    <Modal
      variant='dialog'
      title='Delete Community Win'
      ignoreExtraPadding={true}
      isOpen={isOpen}
      headerDivision='divider'
      onClose={closeModal}
      primaryCTA={{
        text: 'Delete Community Win',
        callback: deleteCommunityWin,
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: closeModal,
      }}
    >
      <div className='md:w-[460px]'>
        <div className='flex flex-col gap-4 w-full'>
          Are you sure you want to delete this community win?
        </div>
      </div>
    </Modal>
  );
};
